import {IActiveFolders} from "./types";
import {createAction, createAsyncAction} from "typesafe-actions";

export interface IModifyingActiveFolders {
    activeFolders: Partial<IActiveFolders>
}

export const modifyingActiveFolders =
    createAction('MODIFYING_ACTIVE_FOLDERS', action => {
        return (params: IModifyingActiveFolders) => action(params);
    })


export interface ILoadActiveFolders {
}

export const loadActiveFoldersAction =
    createAction('LOAD_ACTIVE_FOLDERS', action => {
        return (params: ILoadActiveFolders) => action(params);
    })


export const reLoadActiveFoldersAsyncAction = createAsyncAction(
    'LOAD_ACTIVE_FOLDER_REQUEST',
    'LOAD_ACTIVE_FOLDER_SUCCESS',
    'LOAD_ACTIVE_FOLDER_FAILURE'
)<{}, { activeFolders: IActiveFolders }, { error: Error }>();
